import React, { useCallback, useEffect, useState } from 'react'
import Modal from 'components/VirtualPortal/components/Modal'
import initializeHelperText from 'utilities/helperText.js'
import handleTiming, { meetingHasEnded, meetingHasStarted } from 'components/VirtualPortal/helpers/handleTiming'
import EvaluationModal from './EvaluationModal.jsx'
import RowButton from './RowButton.jsx'

const OneOnOneTimeslotRow = ({ oneOnOneTimeslot }) => {
  const [ state, setState ] = useState({
    joinStatus: oneOnOneTimeslot.event_one_on_one_meeting?.current_participant_joined,
    evaluationCompleted: oneOnOneTimeslot.event_one_on_one_meeting?.evaluation_completed,
    meetingEnded: meetingHasEnded(oneOnOneTimeslot),
    meetingHasStarted: meetingHasStarted(oneOnOneTimeslot),
    confirmModalIsOpen: false,
    errorModalIsOpen: false,
    meetingPrecheckModalIsOpen: false,
    meetingPrecheckModalContent: '',
    meetingPrecheckResult: '',
    oneOnOneTimeslotOptOut: false
  })

  const setNewState = useCallback((data) => setState({...state, ...data }),[state])

  useEffect(() => {
    handleTiming(oneOnOneTimeslot, setNewState)
    initializeHelperText()
  },[oneOnOneTimeslot])

  const addToCalendarLink = useCallback(() => {
    const addToCalendar = () => {
      window.api.get(`/virtual_portal/one_on_one_calendar_invite/${oneOnOneTimeslot.id}`).then((response) => {
        let filename = response.headers['content-type'].replace('text/calendar;', '')
        let element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(response.data))
        element.setAttribute('download', filename)
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      })
    }
    
    if(state.meetingEnded){
      return <a onClick={ () => addToCalendar()} className='add-to-calendar'><i className='fa fa-calendar' aria-hidden='true'></i> ADD TO CALENDAR</a>
    }
  },[state])
  
  const closeModal = useCallback(() => {
    setNewState({
      confirmModalIsOpen: false,
      errorModalIsOpen: false,
      meetingPrecheckModalIsOpen: false,
      isOpen: false
    })
  },[setNewState])

  return(
    <div className='timeslot session-timeslots'>
      <div>
        <div className='time-block'>{state.oneOnOneTimeslot.time_block}</div>
      </div>
      { state.oneOnOneTimeslot.event_one_on_one_meeting ?
        <div>
          <div className='full-name'>{state.oneOnOneTimeslot.event_one_on_one_meeting?.full_name}</div>
          <div className='title'>{state.oneOnOneTimeslot.event_one_on_one_meeting?.title}</div>
          <div className='account-name'>{state.oneOnOneTimeslot.event_one_on_one_meeting?.organization_name}</div>
          {addToCalendarLink()}
        </div>
        : (state.oneOnOneTimeslot.opt_out_id ? <div><p>This time slot has been blocked.</p></div> : <div><p>TBD</p>{addToCalendarLink()}</div>) }
      <div className="timeslot-btn-div">
        { <RowButton state={state} setState={setNewState}/> }
      </div>
      <Modal
        toggleModal={closeModal}
        isOpen={state.confirmModalIsOpen}
      >
        <div className="generic-info-modal-content">
          <div>
            <p>Are you sure you&apos;d like to cancel this meeting?</p>
            <p>The meeting will be removed for you and {`${state.oneOnOneTimeslot.event_one_on_one_meeting?.full_name}`}.</p>
            <p>This meeting time will also be blocked from your schedule.</p>
          </div>
        </div>
      </Modal>
      <EvaluationModal
        toggleModal={closeModal}
        isOpen={state.isOpen}
        session={oneOnOneTimeslot}
        sessionType='session'
        setNewState={setNewState}
      />
      <Modal
        isOpen={state.meetingPrecheckModalIsOpen}
        toggleModal={closeModal}
        type="empty"
      >
        <div className="generic-info-modal-content">
          <div>
            <h3>Error</h3>
            <div className='modal-content-inner'>{state.meetingPrecheckModalContent}</div>
          </div>
          <hr />
          {state.meetingPreCheckBtn}
        </div>
      </Modal>
      <Modal
        isOpen={state.errorModalIsOpen} 
        toggleModal={closeModal}
        type="cancel"
      >
        <div className="generic-info-modal-content">
          <div>
            <p>It appears this meeting has been changed.</p>
            <p>Please refresh the page for the most recent scheduling.</p>
          </div>
          <div className="button-container">
            <hr />
            <button
              className='btn btn-confirm close-modal'
              onClick={closeModal}>
              CANCEL
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default OneOnOneTimeslotRow